import Component from '../core/Component';
import $ from 'jquery';

export default class Question extends Component
{
    constructor($element)
    {
        super($element)

    }

    prepare()
    {
        this.$element.find('a:not(.wrong)').on('click', ::this.showCorrect)

        this.$element.find('a.wrong').removeClass('wrong').on('click', () => {
            event.preventDefault()
            this.showWrong('Ops, to nebylo správně. <br> Zkus to ještě jednou :-)')
        })
    }

    showCorrect (event) {
        if (!this.$element.hasClass('answered')) {
            event.preventDefault()
            $.get($(event.target).attr('href'))
            this.$element.addClass('answered')
            $(event.target).addClass('question__btn--answered')
            this.$element.append('<div class="question__info">Super, tvoje odpověď je správná :-)</div>')
            this.$element.find('.question__info--error').remove()
        } else {
            event.preventDefault()
        }
    }

    showWrong (html) {
        this.$element.append(`<div class="question__info question__info--error">${html}</div>`)

        setTimeout(() => {
            this.$element.find('.question__info--error').remove()
        }, 9000)
    }
}


// WEBPACK FOOTER //
// ./components/Question.js